import realtors from './realtors.reducer';

const reducer = {
  realtors,
};

export default reducer;
